import { useI18n } from '@/composables/useI18n';
import { useTableQuery } from '@/composables/useTableQuery';
import { useStore } from '@/store';
import {
  createReportMetricsApi,
  type CreateReportMetricsApiOptions,
} from '@/views/reports/report-metrics-api';
import type { DedicatedMetricsBundles } from '@/views/reports/report-metrics-runtime';

export const useReportMetrics = (options?: {
  dedicatedMetricsBundles?: DedicatedMetricsBundles;
}) => {
  const store = useStore();
  const tableQueryApi = useTableQuery();
  const { t } = useI18n();

  return createReportMetricsApi({
    translate: (name) => t(name),
    store: {
      getCustomEvents: () => tableQueryApi.getTableCustomEvents(),
      getCustomColumns: () => store.getCustomColumns(),
      getDimensions: () =>
        store.dimensions as Record<string, { mainColumn?: string; additionalColumns?: string[] }>,
      getMetrics: () => store.metrics as string[],
      getIsHideFilters: () => tableQueryApi.getTableIsHideFilters(),
      getIndependentColumnSettingsEnabled: () => store.user.independentColumnSettingsEnabled,
    },
    getTableQueryForCurrentTab: () => tableQueryApi.getTableQueryForCurrentTab(),
    dedicatedMetricsBundles: options?.dedicatedMetricsBundles,
  });
};

export type { CreateReportMetricsApiOptions, ReportMetricsStoreBindings } from '@/views/reports/report-metrics-api';